import './UpdatedFilterComponent.scss'
import React, { Component } from 'react'
import Select from 'react-select'
import {
  labelFor
} from 'common/util/helper'
import SearchInput from 'react-search-input'
import _ from 'lodash'
import ReactTooltip from 'react-tooltip'
import AddFilterButton from './AddFilterButton'
import RemoveFilterButton from './RemoveFilterButton'

export class TimeframeSelectionComponent extends Component {
  render() {
    const { currentFilter, onUpdateValue, valueOptions, idx } = this.props
    return (
    <div key={idx} className="UpdatedFilterSection__row-search">
      <div className={"UpdatedFilterSection__filter-search"}>
        <div className={"UpdatedFilterSection__timeframe_left"}>&nbsp;</div>
        <div className={"UpdatedFilterSection__timeframe_middle"}>Time Period</div>
        <div className={"UpdatedFilterSection__timeframe_right"}>
          <Select
            value={currentFilter.filter_value}
            onChange={value => onUpdateValue(idx, value && value.value)}
            options={valueOptions}
            placeholder="Select a value"
          />
        </div>
      </div>
  </div>)
  }
}

export class UpdatedFilterComponent extends Component {

  onChangeTextbox = (value) => {
    const { currentFilter, idx } = this.props
    if (currentFilter.filter_value != value) {
      this.props.onUpdateValue(idx, value)
    }
  }

  render() {
    const { currentFilter, onUpdateType, onUpdateValue, typeOptions, valueOptions, typeOptionsConsts, idx,
      onRemove, onApply, lastItem, isLoading, dirty } = this.props

    const applyButtonClassName = `UpdatedFilterSection__apply btn-apply`
    const disableApply = isLoading || !dirty
    const apply = () => {
      if (!isLoading) {
        onApply()
      } else {
        console.log("Still loading!")
      }
    }
    return (
    <div key={idx} className="UpdatedFilterSection__row">
      <div className={"UpdatedFilterSection__filter-row"}>
        <RemoveRowButton idx={idx} onRemove={onRemove} />
        <Select
          value={currentFilter.filter_type}
          onChange={value => onUpdateType(idx, value && value.value)}
          clearable={true}
          backspaceRemoves={true}
          deleteRemoves={true}
          disabled={false}
          options={typeOptions.map(val => {
            return {value: val, label: labelFor(typeOptionsConsts, val)}
          })}
          placeholder="Select a filter type"/>
        {(!valueOptions && currentFilter.filter_type) ? (
            <SearchInput
              className="UpdatedFilterSection__search-filter-control"
              value={currentFilter.filter_value}
              onChange={_.debounce(this.onChangeTextbox, 800)}/>
            ) : (
            <Select
              value={currentFilter.filter_value}
              onChange={value => onUpdateValue(idx, value && value.value)}
              clearable={true}
              backspaceRemoves={true}
              deleteRemoves={true}
              options={valueOptions}
              placeholder="Select a value"
            />)
        }
        { (lastItem) &&
          <div className={"UpdatedFilterSection__apply_button"}>
            <button className={applyButtonClassName} disabled={disableApply} onClick={apply}>Apply filter</button>
          </div>
        }

      </div>
  </div>)
  }
}

export const EndcapCheckboxFilter = ({checkboxOptions}) => (
  <div className="FilteredList__row_left__checkbox_exclusion">
    {!!checkboxOptions.onHold && <label> <input
        type="checkbox"
        checked={checkboxOptions.onHold.toggled}
        onChange={checkboxOptions.onHold.onChange}
        /> Exclude on hold
    </label>}

    {!!checkboxOptions.networkReferrals && <label><input
              type="checkbox"
              checked={checkboxOptions.networkReferrals.toggled}
              disabled={checkboxOptions.networkReferrals.disabled}
              onChange={checkboxOptions.networkReferrals.onChange}
            /> Network Referrals</label>}

    {!!checkboxOptions.excludeDuplicates && <label><input
            type="checkbox"
            checked={checkboxOptions.excludeDuplicates.toggled}
            onChange={checkboxOptions.excludeDuplicates.onChange}
          /> Exclude Duplicates</label>}
  </div>
)

export const RemoveRowButton = ({idx, onRemove}) => (
  <div className="UpdatedFilterSection__filter-row__remove" onClick={() => onRemove(idx)}>
    <RemoveFilterButton />
    <ReactTooltip effect="solid"/>
  </div>
)



export const UpdatedFilterSection = ({addFilter, children, handleSearch, maxLengthReached}) => {
  return (
    <div>
      <div>
        <div className="UpdatedFilterSection__block_full">
          <div className="UpdatedFilterSection__block_left">

            <SearchInput className="SearchInput glyphicon glyphicon-search UpdatedFilterSection__search-left"
                         onChange={_.debounce(handleSearch, 800)}/>
            {(!maxLengthReached) && <AddFilterButton onClick={addFilter} />}
          </div>
          <div className="UpdatedFilterSection__block_right">
            <div className="UpdatedFilterSection__filter-row">
              <div className="TimeSelection__wrapper">
                {children.slice(0, 1)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="UpdatedFilterSection__block_full">
        {children.slice(1)}
      </div>
    </div>
  )
}
